// extracted by mini-css-extract-plugin
module.exports = {"closeModalButton":"ModalCloseButton_closeModalButton__2qAc1"};